module.exports = __webpack_public_path__ + "static/media/CompanyBg.2fcea770.png";